/* eslint-disable react-hooks/exhaustive-deps */
import {
  ButtonPrimeReact,
  DataTablePrimeReact,
  PaginationERP,
  PrimeReactModal,
  TableERP,
} from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useArticulosInvalidation } from "api/Articulo.hook"
import { useCategoriasItems } from "api/Categoria.hook"
import { ArticuloReadingDtoProps } from "api/DTOs/ArticuloReadingDto"
import { SortingCriteria } from "api/interfaces/SortingCriteria"
import DeleteModal from "common/components/Modal/DeleteModal"
import { OpenModalfromDirectAccess } from "common/utils/utils"
import { MODAL_STYLES, PAGINATION_STYLES } from "constants/primereactStyles"
import { ARTICULOS_COLUMNS } from "features/Inventario/constants/articulosColumns"
import EditArticulo from "features/Inventario/forms/EditArticulo/EditArticulo"
import { useAsociarDocumentosInvalidation } from "hooks/useAsociarDocumentos"
import { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useLocation } from "react-router-dom"
import ViewArticulos from "../../components/ViewArticulos"
import useArticulos from "../../hooks/useArticulos"
import "./Articulos.scss"
import { FilterMenu } from "./components/FilterMenu"

const Articulos = () => {
  const { t } = useTranslation()
  const { deleteInfiniteQueryAsociarDoc } = useAsociarDocumentosInvalidation()
  const { updateAllArticulosQueries } = useArticulosInvalidation()

  const location = useLocation()
  const [showWithGrid, setShowWithGrid] = useState(false)
  const [sortingCriteria, setSortingCriteria] = useState<SortingCriteria>({
    sort: undefined,
    property: undefined,
  })
  const [pagination, setPagination] = useState({
    itemsPerPage: 100,
    skipCount: 0,
  })
  const [sortField, setSortField] = useState<string | undefined>(undefined)
  const [sortOrder, setSortOrder] = useState<1 | 0 | -1 | null | undefined>(0)
  const dtRef = useRef<DataTablePrimeReact<object[]> | null>(null)
  const handleResetPagination = () => {
    dtRef.current && dtRef.current?.resetScroll()
    setPagination({
      itemsPerPage: pagination.itemsPerPage,
      skipCount: 0,
    })
  }
  const onSort = ({
    sortField,
    sortOrder,
  }: {
    sortField: string | undefined
    sortOrder: 1 | 0 | -1 | null | undefined
  }) => {
    setSortingCriteria({
      property: sortField ?? undefined,
      sort: sortOrder === 1 ? "ASC" : sortOrder === -1 ? "DESC" : undefined,
    })
    setSortField(sortField)
    setSortOrder(sortOrder)
    handleResetPagination()
  }

  const { categoriasItemsRefetch } = useCategoriasItems()

  const {
    selectedArticulo,
    showDeleteModal,
    setShowDeleteModal,
    showArticuloModal,
    isDownloadingExcel,
    items,
    isLoading,
    totalCount,
    selectedMultipleArticulos,
    selectedArticuloToDelete,
    setServiceQuery,
    editArticulo,
    setShowArticuloModal,
    deleteArticulo,
    handleAskForDelete,
    deleteMultiple,
    downloadExcel,
    setSelectedMultipleArticulos,
    fetchTableData,
  } = useArticulos()

  const isMultiple = selectedMultipleArticulos?.length > 1

  useEffect(() => {
    OpenModalfromDirectAccess(location, "ARTICULO", () =>
      setShowArticuloModal({ show: !showArticuloModal.show, isEdit: false })
    )
  }, [])

  const showDeleteMultipleButton = selectedMultipleArticulos.length > 1

  return (
    <div
      className={`tw-bg-white tw-flex tw-flex-col tw-order-2 tw-z-10 tw-relative tw-w-full tw-max-h-screen tw-h-full tw-max-w-screen tw-overflow-x-hidden ${
        showWithGrid
          ? "tw-overflow-y-scroll custom-scrollbar"
          : "tw-overflow-y-hidden"
      }`}
    >
      <FilterMenu
        maxResultCount={pagination.itemsPerPage}
        serviceQuery={setServiceQuery}
        skipCount={pagination.skipCount}
        sortingCriteria={sortingCriteria}
        isLoading={isLoading}
        totalCount={totalCount}
        showDeleteMultipleButton={showDeleteMultipleButton}
        showDeleteMultipleArticulosModal={() => setShowDeleteModal(true)}
        downloadExcel={downloadExcel}
        isDownloadingExcel={isDownloadingExcel}
        setShowWithGrid={setShowWithGrid}
        setShowArticuloModal={setShowArticuloModal}
        categoriasItemsRefetch={categoriasItemsRefetch}
      />

      {showWithGrid ? (
        // @ts-expect-error TS(2322): Type '{ articulos: never[]; }' is not assignable t...
        <ViewArticulos articulos={items} />
      ) : (
        <div className='tw-flex tw-flex-col tw-h-[calc(100%-98px)] tw-relative'>
          <div className='tw-h-full tw-h-min-0'>
            <TableERP
              refTable={dtRef}
              data-testid='tabla-articulos'
              id='tabla-articulos'
              className='tw-h-full !tw-z-0'
              dataKey='id'
              value={items}
              loading={isLoading}
              columns={ARTICULOS_COLUMNS(t, editArticulo, handleAskForDelete)}
              scrollHeight='calc(100dvh - 60px)'
              selectionMode='checkbox'
              selectionColumnMode='multiple'
              onSort={onSort}
              sortField={sortField}
              sortOrder={sortOrder}
              selection={selectedMultipleArticulos}
              onSelectionChange={({
                value,
              }: {
                originalEvent: React.SyntheticEvent
                value: ArticuloReadingDtoProps[]
                type?: "multiple" | "all" | "checkbox" | "row" | undefined
              }) => setSelectedMultipleArticulos(value)}
              removableSort
              showGridlines
              lazy
              scrollable
              emptyMessage={t("primeReact.table.emptyMessage")}
            />
          </div>
          <PaginationERP
            className={PAGINATION_STYLES}
            totalRecords={totalCount}
            first={pagination.skipCount}
            rows={pagination.itemsPerPage}
            resetScroll={() => {
              dtRef.current && dtRef.current?.resetScroll()
            }}
            setPagination={setPagination}
            optionDropdown={[10, 20, 50, 100]}
            texts={{
              textRowsPerPageDropdown: `${t("pagination.textRowsPag")}`,
              textCurrentPageReport: `${t("pagination.from")}`,
            }}
          />
        </div>
      )}

      <PrimeReactModal
        visible={showArticuloModal.show}
        className='tw-rounded-lg tw-p-6 tw-bg-white'
        baseZIndex={20}
        ptContext={MODAL_STYLES}
        closable={false}
        keepInViewport={false}
        header={
          <div className='tw-flex tw-justify-between tw-items-center tw-mb-6 tw-h-10'>
            <p className='tw-text-2xl tw-font-medium tw-text-primary tw-m-0'>
              {showArticuloModal.isEdit
                ? t("inventario.articulos.modal.headerEdit")
                : t("inventario.articulos.modal.headerNew")}
            </p>
            <ButtonPrimeReact
              className='!tw-p-0 !tw-min-w-0 !tw-bg-white !tw-border-none !tw-text-black'
              onClick={() =>
                setShowArticuloModal({
                  show: false,
                  isEdit: showArticuloModal.isEdit,
                })
              }
            >
              <FontAwesomeIcon
                icon={["fal", "xmark"]}
                className='tw-w-5 tw-h-5'
              />
            </ButtonPrimeReact>
          </div>
        }
      >
        <EditArticulo
          articulo={selectedArticulo}
          deleteInfiniteQueryAsociarDoc={deleteInfiniteQueryAsociarDoc}
          onHide={() => {
            fetchTableData()
            updateAllArticulosQueries()
            setShowArticuloModal({ show: false, isEdit: false })
          }}
          isEdit={showArticuloModal.isEdit}
          t={t}
        />
      </PrimeReactModal>
      <DeleteModal
        visible={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        size='small'
        iconType='remesas'
        buttonLabel={t("nsAssets.modalDelete.confirmLabel")}
        title={
          isMultiple
            ? t("inventario.articulos.modal.multipleArt.deleteButton")
            : t("inventario.articulos.modal.deleteButton")
        }
        message={
          isMultiple ? (
            <span>
              {t("inventario.articulos.modal.multipleArt.questionDeleteInit")}{" "}
              {selectedMultipleArticulos.length}{" "}
              {t("inventario.articulos.modal.multipleArt.questionDeleteFinal")}
            </span>
          ) : (
            <span>
              {t("inventario.articulos.modal.questionDelete")}
              {' "'}
              {selectedArticuloToDelete?.concepto ||
                selectedArticuloToDelete?.numeroReferencia}
              &quot;?
            </span>
          )
        }
        onConfirm={isMultiple ? deleteMultiple : deleteArticulo}
      />
    </div>
  )
}

export default Articulos
